let searchInputGlobal = document.querySelector("#header-global-search-input") 
let collectionId = document.querySelector("#ProductGridContainer")?.getAttribute("col-id") || ""
// Initialize abort controller variable
let abortController = null;
let facetsNames = ["brands", "tags"]
// request data 
let requestData = {
    query: '',
    facets: facetsNames,
    facetFilters: [`collection_ids:${collectionId}`],
    maxValuesPerFacet: 1000,
    hitsPerPage: 40,
    page: 0
};
//   keys for Algoliya
let appId = "SPSQXF4IYY"
let viewKey = "592fba5adc5b8a34e6efd7ac36235a11"
let indexName = "shopify_products"
// let indexName = "best_seller"
// let indexName = ""
// if (indexName1) {
//   indexName = indexName1
//   }else{
//   indexName = indexName2
//   }
// let indexName = indexName1 ? indexName1 : indexName2;



let client = algoliasearch(appId, viewKey);
let index = client.initIndex(indexName);

// === ADD: Lager-hjelpere (trygge, kolliderer ikke med eksisterende) ===
const _sb_cleanStr = (v) => {
  if (v == null) return "";
  if (Array.isArray(v) || typeof v === "object") return ""; // ignorer arrays/objekter (GID m.m.)
  return String(v).replace(/\u00A0/g, " ").trim();
};
const _sb_parseQty = (s) => {
  const re = /^-?\d+\s*(?:\+|stk)?$/i; // rene antallsstrenger
  if (!re.test(s)) return 0;
  const n = parseInt(s, 10);
  return Number.isFinite(n) ? n : 0;
};
const _sb_bestDays = (s) => {
  const m = _sb_cleanStr(s).match(/^Best\.?\s*vare\s+(\d+)\s+dager/i);
  return m ? m[1] : "";
};
const _sb_expectedFrom = (s) => {
  const m = _sb_cleanStr(s).match(/Ubekreftet\s+(\d{2}\.\d{2}\.\d{2,4})/i);
  return m ? m[1] : "";
};

// Debounce function implementation
function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }
//   func ends
// function predictive search request
function createPredictiveSearch(query){
    let spinner = document.querySelector("header").querySelector('.spinner-sm')
    // active spinner 
    spinner.classList.add("spinner")
    // active skeleton
    replacePredictiveSkeleton(".predictive-search-loading-state")
    if (abortController) {
        abortController.abort();
    }
    // Create new controller for current request
    abortController = new AbortController();
    // setting newreqdata and removing unnecessary fields
    // let newReqData = {...requestData}
    let newReqData = {...requestData};
    newReqData = JSON.parse(JSON.stringify(newReqData));
    console.log("new req data",newReqData)
    newReqData.facetFilters = ""
    newReqData.maxValuesPerFacet = 1
    // newReqData.hitsPerPage = 100
    // if query empty? set hits to 0
    if(query == ""){
        newReqData.hitsPerPage = 0
    }
     // if request us in progress ? then return
    //  if (isRequestInProgress) return
     // if not then set it true
    //  isRequestInProgress = true;
    newReqData.id = ""

    newReqData.attributesToHighlight = ['title','additional_data.introduction','sku'];             // which fields to mark
  newReqData.highlightPreTag      = '<mark class="predictive-mark">';
  newReqData.highlightPostTag     = '</mark>';

  newReqData.disableTypoToleranceOnAttributes = ['title', 'sku'];

    // requestData = ""
    console.log(newReqData)
    index.search(query, newReqData).then(({hits}) => {
        createPredictiveUI(hits, query , 10)
    }).catch(error => {
        if (error.name !== 'AbortError') {
            console.error("Error performing search:", error);
            console.error('Fetch error:', error);
        }
    }).finally(() => {
        // setting the is request in progress false
        // isRequestInProgress = false
    });

}
// function predictive search  ends
let deboundpredictiveSearch = debounce(createPredictiveSearch,400)

// function predictive search UI 
function createPredictiveUI(products, query, limit) {
  console.log( "query",query)
    let spinner = document.querySelector("header").querySelector('.spinner-sm');
    spinner.classList.remove("spinner");

    let predictiveContainer = document.querySelector("header")?.querySelector(".predictive-search-loading-state");

    // ✅ Filter only ACTIVE products
    // products = products.filter(product => product.status === 'ACTIVE');
    products = products.filter(product => product.price >= 1 );
      // let sortedProducts = products.sort((a, b) => b.order_count - a.order_count);
   let sortedProducts = products.sort((a, b) => {
          // Prioritize matching SKU
          if (a.sku === query && b.sku !== query) return -1;
          if (b.sku === query && a.sku !== query) return 1;
        
          // Otherwise sort by order_count descending
          return b.order_count - a.order_count;
        }).slice(0, 10);;
      console.log('sortedProducts order counts' , (sortedProducts?.map(p => p.order_count)))
      console.log('sortedProducts sku' , (sortedProducts?.map(p => p.sku)))
  // sortedProducts = sortedProducts.splice(10); 
    let itemsPredicted = "";
    let wrapper = "";

    if (sortedProducts.length > 0) {
        sortedProducts.forEach((product, i) => {
            let price = product.variants.price ? product.variants.price : product.variants[0].node.price;
            let compareAtPrice = product.variants.compareAtPrice ? product.variants.compareAtPrice : product.variants[0]?.node?.compareAtPrice;
            let salePercent = null;
            let stockStatus = product.variants.inventoryQuantity ? product.variants.inventoryQuantity : product.variants[0]?.node?.inventoryQuantity;
            const product_sku = product.sku;
            const warehouse_stock_status = product.warehouse_stock_status;
            // const active_status = product.status;

            let product_status = "";
            const match = warehouse_stock_status?.match?.(/\b(\d{2})\.(\d{2})\.(\d{4})\b/);

            if (match) {
                const [, day, month, year] = match;
                product_status = `${day}.${month}.${year.slice(2)}`;
            }else if(warehouse_stock_status == "0" || warehouse_stock_status == null ){
              product_status = "Ikke på lager";
            }
            else {
                product_status = warehouse_stock_status;
            }

            let wareHouseQuantity = product.metafields[1]?.value ? product.metafields[1]?.value : null;

            if (compareAtPrice && compareAtPrice > price) {
                let saleVal = ((compareAtPrice - price) / compareAtPrice) * 100;
                salePercent = Math.floor(saleVal);
            }
          const metafields = product.metafields || [];
        const product_introduction = metafields.find(metafield => metafield.key === 'product_introduction');
        const introText = product.additional_data?.introduction || product_introduction?.value || '';

        // === ADD: Regn ut lagerflagg til ternary-blokka ===
const _st = (parseInt(String(stockStatus ?? 0), 10) || 0);

// Les warehouse-kilder fra dine felter (robust mot string/obj/array)
const _whQtyRaw = product?.metafields?.[1]?.value ?? product?.warehouse_quantity ?? "";
const _whStatObj = (product?.warehouse_status && typeof product.warehouse_status === "object")
  ? product.warehouse_status
  : {
      quantity: product?.warehouse_stock_status,
      expectedDate: product?.warehouse_expected_date
    };

// Normaliser to kandidater
const _s1 = _sb_cleanStr(_whQtyRaw);
const _s2 = _sb_cleanStr(_whStatObj?.quantity);

// Antall tolkes kun hvis rene antallstrenger (ikke GID/tekst)
const _n1 = _sb_parseQty(_s1);
const _n2 = _sb_parseQty(_s2);
const _whQty = Math.max(_n1, _n2);

// “Best. vare X dager”
const bestDays = _sb_bestDays(_s1) || _sb_bestDays(_s2);

// Forventet-dato fra tekst eller felt
const expectedDateStr =
  _sb_expectedFrom(_s1) ||
  _sb_expectedFrom(_s2) ||
  _sb_cleanStr(_whStatObj?.expectedDate) ||
  _sb_cleanStr(product?.warehouse_expected_date) ||
  _sb_cleanStr(product?.expected_date);

// Flagg brukt av templaten din
const inStock    = (_st >= 1) || (_whQty >= 1);
const showBest   = (_st <= 0) && !!bestDays;
const showExp    = (_st <= 0) && !showBest && !!expectedDateStr;
const outOfStock = (_st <= 0) && !inStock && !showBest && !showExp;

            itemsPredicted += `
           <li id="predictive-search-option-product-${i}" 
      class="predictive-search-list-item predictive-search-list-item-product " 
      role="option" 
      aria-selected="false">
                <a href="/products/${product.handle}" class="predictive-search-item predictive-search-item-link" tabindex="-1">
                    <div class="predictive-search-item-image-wrap color-background-2">
                    ${salePercent && salePercent > 0 ? 
                        `<div class="sale_badge_mobile"> 
                            <span class="sale_tage">-${salePercent}% </span>
                         </div>` : ``
                    } 
                        <div class="aspect-ratio" style="--ratio-percent: 75.0%;">
                            <img src="${product.image}" alt="${product.title}" width="108" height="81" loading="lazy" class="predictive-search-item-image">
                        </div>
                        <div class="stock_and_inventory_wrap_mobile">${
  inStock
  ?
  `
  <div class="stock_status_wrap stock_status_wrap--in">
    <span><span class="badge-stock-icon pfu-stock-dot"></span>På lager</span>
  </div>
  `
  :
  showBest
  ?
  `
  <div class="stock_status_wrap stock_status_wrap--expected">
    <span><span class="badge-stock-icon pfu-stock-dot"></span>${bestDays} dager</span>
  </div>
  `
  :
  showExp
  ?
  `
  <div class="stock_status_wrap stock_status_wrap--expected">
    <span><span class="badge-stock-icon pfu-stock-dot"></span>${expectedDateStr}</span>
  </div>
  `
  :
  outOfStock
  ?
  `
  <div class="stock_status_wrap stock_status_wrap--out">
    <span><span class="badge-stock-icon pfu-stock-dot"></span>Ikke på lg.</span>
  </div>
  `
  : ``
}
                        
                        </div>
                    </div>
                    <div class="predictive-search-item-content">
                        <span class="visually-hidden">Leverandør</span>
                        <div class="predictive-search-item-vendor">
                        ${product._highlightResult?.title?.value || product.title}
                        </div>
                        <h3 class="predictive-search-item-heading typography-body">
                        ${product._highlightResult?.additional_data?.introduction?.value || introText}
                        </h3>
                        <div class="price">
                            <div class="price-container">
                            ${salePercent && salePercent > 0 ? 
                                `<span class="sale_tag_card_per absolute_card-tag_media">-${salePercent}% Salg</span>` : ``
                            }
                                <div class="price-regular">
                                    <span class="visually-hidden">Vanlig pris</span>
                                    <span class="price-item price-item-regular">
                                        ${price}kr
                                        <span class="sup">inkl. mva</span>
                                    </span>
                                </div>
                                ${compareAtPrice > price ? `
                                <div class="price-compare">
                                    <span class="price-item price-item-compare">
                                        ${compareAtPrice}kr
                                    </span>
                                </div>` : ``}
                            </div>
                        </div>
                        <div class="stock_and_inventory_wrap">
                          ${stockStatus >= 1 ? `
                              <div class="stock_status_wrap">
                                <span>
                                <span class="badge-stock-icon"></span> <span>  På lager </span>
                              </div>` : ``}
                          ${wareHouseQuantity && wareHouseQuantity > 0 ? `
                              <div class="badge-stock badge-stock-in hidden">
                                  <span class="badge-stock-icon"></span> 
                                  <span class="badge-stock-icon"></span> <span>  På lager </span>
                              </div>` : ``}
                          ${stockStatus <= 0 ? `
                              <div class="badge-stock badge-stock-in">
                                  <span class="badge-stock-icon"></span> 
                                  <span>Hovedlager: ${product_status} </span>
                              </div>` : ``}
                        </div>
                        <span class="product_sku">
                        Varenr: ${product._highlightResult?.sku?.value || product_sku}
                        </span>
                    </div>
                </a>
            </li>
            `;
        });

        wrapper = `
        <div class="predictive-search-results-group-wrapper">
            <div class="predictive-search-results-group"></div>
            <div class="predictive-search-results-group">
                <div class="predictive-search-results-group-section">
                    <h3 id="predictive-search-products" class="predictive-search-heading predictive-search-heading-products h5">
                        Produkter
                    </h3>
                    <ul id="predictive-search-results-item-product-list" class="predictive-search-results-item-list">
                        ${itemsPredicted}
                    </ul>
                </div>
            </div>
        </div>
        `;

        if (predictiveContainer.childElementCount > 1) {
            let suggestionsDiv = predictiveContainer.lastElementChild;
            suggestionsDiv.remove();
        }
        predictiveContainer.innerHTML += wrapper;

    } else {
        // No active products found
        if (predictiveContainer.childElementCount > 1) {
            let suggestionsDiv = predictiveContainer.lastElementChild;
            suggestionsDiv.remove();
        }
    }
}


// function to replace inner html with products
function replacePredictiveSkeleton(containerSelector) {
    const container = document.querySelector("header").querySelector(containerSelector);
    if (!container) return;
    let predictiveHTML = '';
    for (let i = 0; i < 1; i++) {
        predictiveHTML += createPredictiveSkeleton();
    }
    while (container.childElementCount > 1) {
        container.removeChild(container.lastElementChild);
    }

    container.innerHTML += predictiveHTML;
}
// func ends
function createPredictiveSkeleton(){
    return `
    <div class="predictive-search-results-group-wrapper ">
        <div class="predictive-search-results-group"></div>
        <div class="predictive-search-results-group"><div class="predictive-search-results-group-section">
            <h3 id="predictive-loading-skeleton-heading" class="predictive-search-heading predictive-search-heading-products h5">
            
            </h3>
            <ul id="predictive-search-results-item-product-list" class="predictive-search-results-item-list">
                <li id="predictive-loading-skeleton-item">
                </li>
                <li id="predictive-loading-skeleton-item">
                </li>
                <li id="predictive-loading-skeleton-item">
                </li>
            </ul>
        </div>
    </div>
    `
}
// function to clear predictive search
function clearPredictiveUI(containerSelector){
    const container = document.querySelector("header").querySelector(containerSelector);
    if (!container) return;
    while (container.childElementCount > 1) {
        container.removeChild(container.lastElementChild);
    }
}
// function to clear predictive search ends
document.addEventListener("DOMContentLoaded",() => {
    searchInputGlobal?.addEventListener("input",(e)=>{
        // if length of search characters is greater than 3 then search query
        if (e.target.value.length > 0) {
            requestData.query = e.target.value
            // Clear the previous timeout if there was one
            // clearTimeout(timeoutId);
            // timeoutId = setTimeout(() => {
                deboundpredictiveSearch(e.target.value)
            // }, 500);
        }
        // else if search is cleared ? then getting all products
        else if (e.target.value.length === 0) {
            requestData.query = e.target.value
            // Clear the previous timeout if there was one
            // clearTimeout(timeoutId);
            // timeoutId = setTimeout(() => {
                // deboundpredictiveSearch(e.target.value)
                clearPredictiveUI(".predictive-search-loading-state")
            // }, 500); 
        }
    })
    // if ai search is enabled ? then active its class
    let aiBtn = document.querySelectorAll("#ai-toggle")
    if(aiSearch === "true"){
        aiBtn.forEach(btns=>{
            btns.classList.add("active")
        })
    }
})

